import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/succeed.png'


const _withScopeId = n => (_pushScopeId("data-v-75663c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainBody" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "succeedWrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "succeedPhoto"
  }),
  /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"20px"} }, "购买成功")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTitle" }, "实名认证二维码", -1))
const _hoisted_4 = ["src"]

import { useRouter, useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { showDialog } from "vant";
import { getWifiCustomizationCardQueryCardMsg, getWifiCustomizationCardRealName, getOrderList } from "@/api";
import { getRealNameAction, shouldPromptRealName } from "@/utils/realNameAccess";


export default /*#__PURE__*/_defineComponent({
  __name: 'packageSucceeds',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const showImage = ref(false);
const imageUrl = ref("");

onMounted(() => {
  const iccid = route.params.iccid as string;
  if (!iccid) return;

  Promise.all([
    getWifiCustomizationCardQueryCardMsg({ iccid }),
    getOrderList({ iccid })
  ]).then(([cardRes, orderRes]: any[]) => {
    const orders = orderRes?.code === 200 && Array.isArray(orderRes.result) ? orderRes.result : [];
    if (cardRes?.code !== 200 || !shouldPromptRealName(cardRes.result, orders)) return;

    getWifiCustomizationCardRealName({ iccid }).then((realNameRes: any) => {
      const authWay = Number(realNameRes?.result?.authWay);
      const url = realNameRes?.result?.url;
      if (realNameRes?.code !== 200 || !url) return;
      const action = getRealNameAction(authWay, url);

      showDialog({
        title: "请完成实名认证",
        message: "套餐购买成功后，请及时完成实名认证。完成认证后，卡片才能正常使用相关服务。",
        showCancelButton: true,
        confirmButtonText: "去实名认证",
        cancelButtonText: "稍后再说",
      }).then(() => {
        if (action === "qr") {
          imageUrl.value = url;
          showImage.value = true;
          return;
        }
        window.location.href = url;
      }).catch(() => {});
    }).catch(() => {});
  }).catch(() => {});
});

function toHome() {
  router.push({
    name: route.query.source === "watchHome" ? "watchHome" : "wristWatch",
    params: {
      iccid: route.params.iccid as string,
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_button, {
      color: "#FF7744",
      block: "",
      onClick: toHome
    }, {
      default: _withCtx(() => [
        _createTextVNode("首页")
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: showImage.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showImage).value = $event)),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("img", {
          src: imageUrl.value,
          alt: "实名认证二维码",
          class: "qrImg"
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})